import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { EpdkSnackBarComponent } from './snack-bar.component';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatIconModule,
    MatSnackBarModule
  ],
  declarations: [EpdkSnackBarComponent]
})
export class EpdkSnackBarModule { }
